<script setup lang="ts">
import type { StoryblokAsset } from '../../types'

interface Props {
  blok: {
    images: StoryblokAsset[]
  }
}

const props = defineProps<Props>()
const imagesProcess = computed(() => {
  return props.blok.images.map(items => ({
    ...items,
    source: optimizeImage(items.filename),
  }))
})
</script>

<template>
  <div class="flex w-full justify-center items-center max-w-[780px] gap-5 md:gap-11">
    <div v-for="item in imagesProcess" :key="item.id" class="flex justify-center items-center w-auto sm:w-[33.3%] max-w-[135px]">
      <img :src="item.source" :alt="item.alt" class="max-h-[20px] sm:max-h-[48px] w-full object-contain">
    </div>
    <span class="text-xs font-inter font-700 leading-[160%] text-darkGray">
      and others
    </span>
  </div>
</template>

<style scoped>
.my-swiper {
  width: 100%;
}
</style>
